<template>
  <ul :class="$style.faqList">
    <li v-for="(item, index) in items" :key="`item-${index}`" :class="$style.item">
      <Heading
        :class="[$style.question, { [$style.questionAlwaysOpen]: item.isAlwaysOpen }]"
        :tag="HEADINGS.h4"
        @click="$set(isOpen, index, !isOpen[index])"
      >
        <LineBreakResolver :text="item.question" :isResolvingLastWord="false" />
        <IconCirclePlus :class="$style.iconPlus" :isMinus="!!isOpen[index]" />
      </Heading>
      <Accordion :isOpen="!!isOpen[index] || !!item.isAlwaysOpen" :transitionTime="400">
        <LineBreakResolver
          :class="[$style.answer, { [$style.visible]: !!isOpen[index] || !!item.isAlwaysOpen }]"
          tag="div"
          :text="item.answer"
          :isFormattingLinks="true"
          :isFormattingLineBreakChars="true"
        />
      </Accordion>
    </li>
  </ul>
</template>

<script>
import Accordion from '@/components/Accordion.vue'
import Heading, { HEADINGS } from '@/components/Heading/Heading.vue'
import IconCirclePlus from '@/components/_icons/IconCirclePlus.vue'
import LineBreakResolver from '@/components/LineBreakResolver.vue'

export default {
  name: 'FaqList',
  components: {
    Accordion,
    Heading,
    IconCirclePlus,
    LineBreakResolver,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
      validator(items) {
        const isString = v => typeof v === 'string'
        const isBooleanOrUndefined = v => typeof v === 'boolean' || typeof v === 'undefined'
        return items.every(item => {
          return (
            isString(item.question) &&
            isString(item.answer) &&
            isBooleanOrUndefined(item.isAlwaysOpen)
          )
        })
      },
    },
  },

  data() {
    return {
      isOpen: {},
      HEADINGS,
    }
  },
}
</script>

<style lang="scss" module>
$question-padding-y: 18px;
$question-line-height: 1.3;
$icon-plus-size: 24px;

.faqList {
  padding: 30px 0 130px;
}

.item {
  border-bottom: 1px solid $color-light-grey-3;
}

.faqList {
  .question {
    position: relative;
    margin: 0;
    padding: $question-padding-y 45px $question-padding-y 0;
    line-height: 1.3;
    color: $color-high-contrast-text-light;
    cursor: pointer;
    transition: 0.3s color;

    @include min-screen($mq-full) {
      padding-right: 55px;
    }

    &:not(.questionAlwaysOpen):hover {
      color: $color-black;
    }

    &.questionAlwaysOpen {
      padding-right: 0;
      cursor: default;

      .iconPlus {
        display: none;
      }
    }
  }
}

.iconPlus {
  position: absolute;
  top: 50%;
  right: 1px;
  width: $icon-plus-size;
  height: $icon-plus-size;
  color: $color-brand-green;
  transform: translateY(-50%);
  transition: 0.3s color;
}

.answer {
  padding: 0 0 15px;
  opacity: 0;
  transform: translateY(-5px);
  transition: 0.4s opacity ease-in-out;

  &.visible {
    opacity: 1;
  }
}
</style>
